import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { CompanySchema } from "./Company";
import { UserSchema } from "./User";

export const DocumentOfferFieldsSchema = z.object({
  id: z.number().int(),
  accountUser: z.any(),
  company: CompanySchema,
  companyName: z.string(),
  createDate: z.string(),
  creatorAccountUser: AccountUserSchema,
  currencyCode: z.string(),
  customerDetails: z.string(),
  defaultAddress: z.string(),
  documentHeader: z.string(),
  documentSeriesDefinition: z.any(),
  documentStatus: z.number().int(),
  endDate: z.string(),
  exchange: z.any(),
  exchangeHistory: z.any(),
  exchangeRatio: z.number(),
  modificationDate: z.string(),
  nip: z.string(),
  notes: z.string(),
  orderTime: z.string(),
  positions: z.any(),
  user: UserSchema,
  userPh: UserSchema,
  userPhName: z.string(),
  valueNettoBeforeMargin: z.number(),
  valueBruttoBeforeMargin: z.number(),
  valueNettoBeforeMarginInCurrency: z.number(),
  valueBruttoBeforeMarginInCurrency: z.number(),
  valueNetto: z.number(),
  valueBrutto: z.number(),
  valueNettoInCurrency: z.number(),
  valueBruttoInCurrency: z.number(),
});
export const PartialDocumentOfferFieldsSchema =
  DocumentOfferFieldsSchema.deepPartial();

export const DocumentOfferExtraFieldsSchema = z.object({
  attributes: z.array(z.any()),
});
export const PartialDocumentOfferExtraFieldsSchema =
  DocumentOfferExtraFieldsSchema.deepPartial();

export const DocumentOfferSchema = z.intersection(
  DocumentOfferFieldsSchema,
  DocumentOfferExtraFieldsSchema
);

export type DocumentOfferFields = z.infer<typeof DocumentOfferFieldsSchema>;
export type PartialDocumentOfferFields = z.infer<
  typeof PartialDocumentOfferFieldsSchema
>;
export type DocumentOfferExtraFields = z.infer<
  typeof DocumentOfferExtraFieldsSchema
>;
export type PartialDocumentOfferExtraFields = z.infer<
  typeof PartialDocumentOfferExtraFieldsSchema
>;
export type DocumentOffer = z.infer<typeof DocumentOfferSchema>;
